import { createURL, parse } from 'expo-linking'
import type { Href } from 'expo-router'
import { useMemo } from 'react'

import { env } from '@/src/config/env'
import { useMeQuery } from '@/src/features/auth/services/useMeQuery'

import { UTM } from '../constants/utm'

export const useUrlBuilder = () => {
  const { data: me } = useMeQuery()
  const inviteKey = me?.inviteKey

  const withUTM = useMemo(
    () =>
      ({ campaign, route }: { route: Href; campaign: string }) => {
        const parsedRoute =
          typeof route === 'string' ? parse(route) : { path: route.pathname, queryParams: route.params }

        return createURL(`${env.EXPO_PUBLIC_LEGACY_BASE_URL}/${parsedRoute.path?.replace(/^\//, '')}`, {
          queryParams: {
            ...parsedRoute.queryParams,
            ...(inviteKey ? { uik: inviteKey } : {}),
            utm_source: UTM.SOURCE.SHARE,
            utm_medium: UTM.MEDIUM.SHARE,
            utm_campaign: campaign,
          },
        })
      },
    [inviteKey],
  )

  return {
    withUTM,
  }
}
